module.exports = __webpack_public_path__ + "img/长腿瘦身--大图gif.6a7da602.gif";